import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
export default function splitImagesIntoRows(_images, _numRows) {
  var imagesPerRow = Math.floor(_images.length / _numRows);
  var extraImages = _images.length % _numRows; // Remaining images after equal distribution

  var rows = [];
  var start = 0;

  // eslint-disable-next-line no-plusplus
  for (var i = 0; i < _numRows; i++) {
    var end = start + imagesPerRow + (i < extraImages ? 1 : 0); // Add extra images to the first few rows
    rows.push(_sliceInstanceProperty(_images).call(_images, start, end));
    start = end;
  }
  return rows;
}